export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 scroll-mt-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                App下载
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                触手漫画移动端体验即将到来！随时随地，下拉畅读触手漫画全集。
                支持离线缓存、阅读进度同步等实用功能，让阅读触手漫画更加便捷。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  App Store
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-google-play-fill text-lg"></i>
                  Google Play
                </a>
              </div>
              <p className="text-xs text-foreground-400 mt-4">即将上线，敬请期待</p>
            </div>
            <div className="w-48 h-48 md:w-56 md:h-56 flex-shrink-0 relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20smartphone%20mockup%20displaying%20a%20manga%20reader%20app%20interface%20with%20tentacle-themed%20manga%20artwork%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20minimalist%20UI%20design%2C%20floating%20phone%20on%20clean%20white%20background%2C%20product%20mockup%20photography%20style&width=450&height=450&seq=app-mockup-2026&orientation=squarish"
                alt="触手漫画App下载 - 触手漫画移动端阅读体验"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}